export const GROUPING_DAMAGE_REQUEST = "GROUPING_DAMAGE_REQUEST";
export const GROUPING_DAMAGE_SUCCESS = "GROUPING_DAMAGE_SUCCESS";
export const GROUPING_DAMAGE_FAILED = "GROUPING_DAMAGE_FAILED";
